import React, {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import SellerRateForm from '../sellerRateForm/SellerRateForm.tsx';
import ProductRateForm from '../productRateForm/ProductRateForm.tsx';

const OrderRate: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {
        groupOrders,
        isSellerTab: initialTab,
        previousPath,
        date,
        orderNumber,
        orderCount
    } = location.state || {groupOrders: [], isSellerTab: true};




    const [isSellerTab, setIsSellerTab] = useState<boolean>(initialTab);


    const handleGoBack = () => {
        navigate(previousPath || '/profile/orders', {state: {groupOrders, date, orderNumber, orderCount}});
    };

    return (
        <div
            className="p-4 pb-14 sm:p-8 mx-2 sm:mx-4 shadow-lg rounded-lg bg-white overflow-y-auto max-h-[calc(100vh-11rem)]">
            <button onClick={handleGoBack} className="text-primary-color font-medium text-sm mb-4 inline-block">
                {'< Geri Dön'}
            </button>
            <div className="flex text-sm sm:text-base">
                <button
                    className={`mr-4 pb-2 ${isSellerTab ? 'border-b-2 border-primary-color text-primary-color' : 'text-gray-500'}`}
                    onClick={() => setIsSellerTab(true)}
                >
                    Satıcıyı Değerlendir
                </button>
                <button
                    className={`pb-2 ${!isSellerTab ? 'border-b-2 border-primary-color text-primary-color' : 'text-gray-500'}`}
                    onClick={() => setIsSellerTab(false)}
                >
                    Ürünü Değerlendir
                </button>
            </div>

            {isSellerTab ? (
                <SellerRateForm groupOrders={groupOrders}/>
            ) : (
                <ProductRateForm groupOrders={groupOrders}/>
            )}
        </div>
    );
};

export default OrderRate;